import {useI18n} from 'i18n/I18nContext'
import {useOrganizationBilling} from 'organization/Billing/Providers/OrganizationBillingProvider'
import {ImagesList} from 'organization/ImageSelector/ImagesList'
import ImagesProvider from 'organization/ImageSelector/ImagesProvider'
import React from 'react'

export default function ImagesModal() {
  const {t} = useI18n()
  const {imagesModalOpen, setImagesModalOpen, imageSelected} =
    useOrganizationBilling()

  const handleOpenModal = () => {
    setImagesModalOpen(!imagesModalOpen)
  }

  return (
    <>
      <div
        onClick={handleOpenModal}
        className={`offcanvas__overlay ${imagesModalOpen ? 'overlay-open' : ''}`}
      ></div>
      <section
        className={`speaker__popup-area ${imagesModalOpen ? 'open' : ''}`}
        style={{maxWidth: '80%'}}
      >
        <div className="popup__wrapper" style={{maxWidth: '100%'}}>
          <div className="popup__title-wrapper">
            <h3 className="popup__title">{t('orgImages.galleryTitle')}</h3>
          </div>
          <div className="popup__input-wrapper">
            {imagesModalOpen && (
              <ImagesProvider>
                <ImagesList onSelect={imageSelected} />
              </ImagesProvider>
            )}
          </div>
        </div>
      </section>
    </>
  )
}
